/**
 * @fileoverview Filmstrip. Overly complicated due to the responsive nature of the site. Namely,
 * widths and items show cannot be known ahead of time, so it is a bit more expensive to maintain
 * the nice automatic adjusting and resetting.
 */
var Hammer = require('hammerjs');
var util = require('./util');

/**
 * @param {string|Element} el
 * @param {Element} container
 * @constructor
 */
function Filmstrip(el, container) {
  var self = this;
  this.$el = $(el);
  if (!this.$el.length) {
    return;
  }
  this.$container = container ? this.$el.find(container) : this.$el.find('.inertia-filmstrip-inner');

  var children = this.$container.children();
  this.$childrenLen = children.length;
  this.$sampleItem = children.first();
  this.resetCounters();
  this.setHandlers();

  var $innerEl = this.$container;
  var hammertime = new Hammer($innerEl[0]);
  var dragMeta = {
    left: 0,
    maxDistance: this.$sampleItem.width() * (this.$childrenLen -1 ) * -1
  };

  hammertime.on('dragleft dragright', function(event) {
    var delta = event.gesture.deltaX;
    var left = dragMeta.left + delta;

    if (left < 0 && left > dragMeta.maxDistance) {
      $innerEl.css({left: left});
    }
  }.bind(this));

  hammertime.on('dragend', function (event) {
    var currentLeft = parseInt($innerEl.css('left'), 10);
    var idx = this.findClosestByPx(currentLeft * -1);
    dragMeta.left = this.goTo(idx);
  }.bind(this));
}

Filmstrip.prototype.resetCounters = function() {
  this.pos = 0;
  this.currentDistance = 0;
  this.maxMoves = this.$childrenLen - Math.ceil(this.$el.outerWidth() / this.$sampleItem.outerWidth());
};

/**
 * @param {string|Element} el
 */
Filmstrip.prototype.setHandlers = function() {
  var self = this;
  $(window).on('resize', util.debounce($.proxy(self.handleResize, this), 500));

  this.$el.find('.left').on('click', function(e) {
    e.preventDefault();
    self.move(-1);
  });

  this.$el.find('.right').on('click', function(e) {
    e.preventDefault();
    self.move(1);
  });
};

/**
 * On window resize, go back to home. This will prevent us from being in an awkward state
 * where some scroll was accomplished at a different image size.
 */
Filmstrip.prototype.handleResize = function() {
  if (this.pos === 0) {
    return;
  }

  this.$container.animate({
    left: 0
  });

  this.resetCounters();
};

Filmstrip.prototype.findClosestByPx = function (px) {
  return Math.round(px / this.$sampleItem.width());
};

Filmstrip.prototype.goTo = function (idx) {
  this.pos = idx;

  var distance = this.$sampleItem.outerWidth();
  this.currentDistance = distance * idx * -1;

  this.$container.animate({
    left: this.currentDistance
  });

  return this.currentDistance;
};

/**
 * @param {number} dir 1 or -1 for right or left, respectively.
 */
Filmstrip.prototype.move = function(dir) {
  if (this.pos === 0 && dir === -1) {
    return;
  }

  if (this.pos === this.maxMoves && dir === 1) {
    return;
  }

  var distance = this.$sampleItem.outerWidth();
  this.currentDistance += distance*dir*-1;
  this.$container.animate({
    left: this.currentDistance
  });
  this.pos += dir;
};

module.exports = Filmstrip;
